import { Radio as MuiRadio } from '@mui/material'
import { FormControlLabel } from 'elements/inputs/form/form-control-label'

import { RadioIcon } from './radio-icon'

export type Props = Readonly<{
  name: string
  value: string
  selectedValue: string

  onChange?: (value: string) => void
  label?: React.ReactNode
  disablePointerEvents?: boolean
}>

export const Radio = ({
  name,
  value,
  onChange,
  selectedValue,
  label,
  disablePointerEvents,
}: Props) => {
  const control = (
    <MuiRadio
      disableRipple
      name={name}
      value={value}
      checked={value === selectedValue}
      onChange={event => (onChange ? onChange(event.target.value) : undefined)}
      icon={<RadioIcon />}
      checkedIcon={<RadioIcon checked />}
      sx={{
        '&.MuiRadio-root': {
          padding: 0,
        },
      }}
    />
  )

  if (label) {
    return (
      <FormControlLabel
        label={label}
        control={control}
        sx={{ pointerEvents: disablePointerEvents ? 'none' : undefined }}
      />
    )
  }

  return control
}
